import { useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from 'src/components/Button';
// import Checkbox from 'src/components/Checkbox';
import TextInput from 'src/components/TextInput';
import './style.scoped.css';
import { useHistory } from 'react-router-dom';
import {
  confirmQuitFlow,
  formatMoney,
  getReplaceText,
  getReplaceTextMulti,
  isValidReferralCode,
} from 'src/utils';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import closeImg from 'src/assets/close_red.svg';
import PopupService from 'src/utils/PopupService';
import LoadingService from 'src/utils/LoadingService';
import { gaTrackEvent } from '../../api';
import { BUYING_PROCESS, BUYING_PROCESS_STEP, BUYING_PROCESS_TRACKING } from '../../constants';
import UserInfoService from '../../utils/UserInfoService';

interface PaymentObserverProps {
  cancerStore?: CancerStore;
}
const PaymentObserver = observer(({ cancerStore }: PaymentObserverProps) => {
  const { t } = useTranslation();
  // const [isAgree, setIsAgree] = useState(false);
  const history = useHistory();
  const [referralCode, setReferralCode] = useState<string>('');
  const [errReferralCode, setErrReferralCode] = useState<string>('');
  const [discount, setDiscount] = useState<string>('');
  const [errDiscount, setErrDiscount] = useState<string>('');
  // const [focusingReferral, setFocusingReferral] = useState(false);

  const _handleConfirmPay = () => {
    if (
      referralCode &&
      referralCode.trim() &&
      !isValidReferralCode(referralCode)
    ) {
      setErrReferralCode(t('err_referral_code'));
      return;
    }

    gaTrackEvent(BUYING_PROCESS_TRACKING,
      BUYING_PROCESS[BUYING_PROCESS_STEP.ConfirmPayment].name,
      UserInfoService.getUserInfo()?.idCardNo ?? "");

   //Thuc hien bo sung check TSA
    cancerStore.fetchCheckBpTsaForPayment(
        cancerStore.formInfo?.choosedInsurancePackage,
        +cancerStore.insurancePackages?.find(item =>item.id == cancerStore.formInfo?.choosedInsurancePackage).insamountAm,
        history
    ).then(value => {
      cancerStore.requestCreateOrder(referralCode, history);
    });


  };

  const _handleClose = () => {
    confirmQuitFlow(history);
  };

  const _handleBack = () => {
    setDiscount('');
    setErrDiscount('');
    cancerStore.cancelApplyDiscount();
    history.goBack();
  };

  const _handleChangeReferralCode = useCallback((e) => {
    setReferralCode(e.target.value);
    setErrReferralCode(null);
  }, []);

  const _handleChangeDiscount = useCallback((e) => {
    setDiscount(e.target.value.toUpperCase());
    setErrDiscount(null);
  }, []);

  const _handleApplyDiscount = async () => {
    if (!discount || !discount.trim()) return;
    setErrDiscount(null);
    cancerStore.cancelApplyDiscount();
    try {
      await cancerStore.applyDiscount(discount);
    } catch (err) {
      console.log('applyVoucher err', err?.response, err?.response?.status);
      LoadingService.instance.current.close();
      if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'MSG01'
      ) {
        setErrDiscount(err?.response?.data?.error_message);
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
    }
  };

  const _handleCancelDiscount = () => {
    setDiscount('');
    setErrDiscount('');
    cancerStore.cancelApplyDiscount();
  };

  const _getDiscountText = () => {
    if (!cancerStore.insuranceDiscountInfo) return '';
    const discount = cancerStore.insuranceDiscountInfo;
    if (discount.calType === '1') {
      if (!discount.discountValueMax) {
        return getReplaceText(t('discount-first-year'), discount.discountValue);
      }
      return getReplaceTextMulti(t('discount-first-year-with-limit'), [
        discount.discountValue?.toString(),
        formatMoney(discount.discountValueMax?.toString()),
      ]);
    } else if (discount.calType === '2') {
      return getReplaceText(
        t('discount-first-year-vnd'),
        formatMoney(discount.discountValueMin)
      );
    } else if (discount.calType === '3') {
      return getReplaceText(
        t('discount-first-year-vnd-remain'),
        formatMoney(discount.discountFixedValue)
      );
    }
    return '';
  };

  return (
    <div className="screen-container bg-background">
      <Toolbar
        title={t('confirm_pay')}
        type="normal"
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <div className="screenScrollContainer">
        <div className="cardItemTransparent labelText">
          {t('im_agree_pay_with_info')}:
        </div>
        <div className="cardItemNoPadding">
          <div className="blockTitle blockTitleContainer">{t('pay_info')}</div>
          <div className="px-4 pb-6 pt-6">
            <div className="flex flex-row pb-6">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('insurrance_fee')}
              </div>
              <div className="smallTitle2">
                {formatMoney(cancerStore.selectedPackage.premiumAm)}{' '}
                {cancerStore.selectedPackage.currencyId}
              </div>
            </div>
            {cancerStore.insuranceDiscountInfo && (
              <div className="flex flex-row pb-6">
                <div className="flex-1 bodyText2 text-onSurfaceVariant">
                  {t('decrease_amount')}
                </div>
                <div className="smallTitle2">
                  -{formatMoney(cancerStore.insuranceDiscountInfo?.discountAmt)}{' '}
                  {cancerStore.selectedPackage.currencyId}
                </div>
              </div>
            )}
            {cancerStore.insuranceDiscountInfo && (
              <div className="flex flex-row pb-6">
                <div className="flex-1 bodyText2 text-onSurfaceVariant">
                  {t('insurance_fee_after_discount')}
                </div>
                <div className="smallTitle2Primary">
                  {formatMoney(
                    cancerStore.insuranceDiscountInfo?.afterDiscount
                  )}{' '}
                  {cancerStore.selectedPackage.currencyId}
                </div>
              </div>
            )}
            <div className="flex flex-row pb-6 border-b border-line">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('term_fee')}
              </div>
              <div className="smallTitle2">{t('anual')}</div>
            </div>
            <div className="flex flex-row pt-5">
              <div className="flex-1 smallTitle2">{t('pay_money')}</div>
              <div className="blockTitlePrimary">
                {formatMoney(
                  cancerStore.insuranceDiscountInfo
                    ? cancerStore.insuranceDiscountInfo.afterDiscount
                    : cancerStore.selectedPackage.premiumAm
                )}{' '}
                {cancerStore.selectedPackage.currencyId}
              </div>
            </div>
          </div>
        </div>
        {/* {cancerStore.insuranceDiscountInfo &&
          cancerStore.vouchers &&
          cancerStore.vouchers.length > 0 && (
            <div className="cardItemNoPadding">
              <div className="blockTitle blockTitleContainer">
                {t('apply_voucher')}
              </div>
              <div className="px-4 pt-5 pb-6">
                <TextInput
                  value={cancerStore.selectedVoucher.voucherCode}
                  maxLength={50}
                  type={'text'}
                  error={false}
                  helperText={cancerStore.insuranceDiscountInfo.title}
                  disabled={true}
                />
              </div>
            </div>
          )} */}

        <div className="cardItemNoPadding">
          <div className="blockTitle blockTitleContainer">
            {t('apply_voucher2')}
          </div>
          <div className="px-4 pt-5 pb-6">
            <div className="flex flex-row w-full">
              <div className="flex-1 pr-4">
                <TextInput
                  value={discount}
                  onChange={_handleChangeDiscount}
                  maxLength={50}
                  type={'text'}
                  error={!!errDiscount}
                  helperText={errDiscount}
                  rightComponent={
                    discount ? (
                      <img
                        src={closeImg}
                        className="clearIcon"
                        onClick={_handleCancelDiscount}
                      />
                    ) : (
                      <div />
                    )
                  }
                />
              </div>

              <Button
                buttonType={ButtonTypes.primaryFilled}
                text={t('apply')}
                onClick={_handleApplyDiscount}
                extraClassName="applyBtn"
              />
            </div>
            <div className={`helperText`}>{_getDiscountText()}</div>
          </div>
        </div>

        <div className="cardItemNoPadding">
          <div className="blockTitle blockTitleContainer">
            {t('referral_code')}
          </div>
          <div className="px-4 pt-5 pb-6">
            <TextInput
              placeholder={t('referral_code_hint')}
              value={referralCode}
              onChange={_handleChangeReferralCode}
              maxLength={50}
              type={'text'}
              inputMode={'numeric'}
              error={!!errReferralCode}
              helperText={errReferralCode}
            />
            {!errReferralCode && (
              <div className={`helperText`}>{t('referral_code_guide')}</div>
            )}
          </div>
        </div>
      </div>

      <div className="bottomButtonBlock">
        <div className="flex flex-row">
          <Button
            text={t('confirm_pay')}
            buttonType={ButtonTypes.primaryFilled}
            extraClassName="w-full"
            onClick={_handleConfirmPay}
            disabled={!!errDiscount}
          />
        </div>
      </div>
    </div>
  );
});

const Payment = () => <PaymentObserver cancerStore={cancerStore} />;
export default Payment;
